module.exports = __webpack_public_path__ + "static/aus_logo_colour-41200ba8ad980ab6c81c4cea84d2d453.png";